/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	AnalyticsCampaignMetaAnalyticsPathParams,
	AnalyticsCampaignMetaAnalyticsResponse,
} from '../types/AnalyticsCampaignMetaAnalytics'

/**
 * GET /campaigns/:campaign/meta-analytics
 * @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::campaignMetaAnalytics
 */
export async function analyticsCampaignMetaAnalytics(
	campaign: AnalyticsCampaignMetaAnalyticsPathParams['campaign'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AnalyticsCampaignMetaAnalyticsResponse>> {
	return axiosInstance.get(`/campaigns/${campaign}/meta-analytics`, config)
}
